// Departments — the desktop app's per-department channels. A user may be placed in departments (the
// notifications are counted by department, and the Service team is found by it). What a person may see and
// do comes from their roles alone; each department's role carries its standard access, the pages of its own
// section of the menu (rbac.ts DEPARTMENT_STANDARD). (Departments once also had their own page lists, ANDed
// with the permissions; those hid pages people were granted and were dropped.)
/** Departments, in display order (matches the desktop app). */
// Departments mirror the functional roles 1:1 (see rbac.ts ROLES), minus Administrator and the
// read-only roles (Viewer / Read Only), which are permission-only.
export const DEPARTMENTS = [
    { id: 'administration', label: 'Administration' },
    { id: 'moderator', label: 'Moderator' },
    { id: 'sales', label: 'Sales' },
    { id: 'assembly', label: 'Assembly' },
    { id: 'service', label: 'Service' },
    { id: 'grp', label: 'GRP' },
    { id: 'quality_control', label: 'Quality Control' },
    { id: 'engineering', label: 'Engineering' },
    { id: 'procurement', label: 'Procurement' },
    { id: 'accounting', label: 'Accounting' },
    { id: 'warehouse', label: 'Warehouse' },
    { id: 'logistics', label: 'Logistics' },
];
export const DEPARTMENT_IDS = DEPARTMENTS.map((d) => d.id);
//# sourceMappingURL=departments.js.map